import React from 'react';
import HomePageStyle from './Styles';
import Footer from '../../../components/common/footer/Footer';
import { useNavigate } from 'react-router-dom';
import loginRight from '../../../assets/img/MS-Login-right-img.png';
import appleStore from '../../../assets/img/MS-mbl-site-apple-img.png';
import playStore from '../../../assets/img/MS-mbl-site-play-store-img.png';
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
const HomePage = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <div>
      <section className="heroSection">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heroContent">
                <h1>Empowering Surgeons and Interventionalists with AI-Driven Solutions.</h1>
                <p>
                  Casez is a cutting-edge HIPAA-compliant application that allows surgeons and interventionalists to build their patient database, log their procedures quickly and securely, and maximize their financial returns, by leveraging the power of AI and natural language processing (NLP).
                </p>
                <a onClick={() => navigate('/plans')} className="bgBlue pointer">Start your own plan</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mblSite homePage">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="mblSiteImg">
                <img style={{ width: '100%' }} src={loginRight} alt=""></img>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mblSiteContent">
                <h2>Mobile Site and Application</h2>
                <p>Our mobile site and application allow you to add and check your patients and procedures anytime and anywhere. You can also use it to search, add patient data and images, follow-up information, export cases and much more.</p>
                <h4>Get Casez now and start building your cases database.</h4>
                <div className="mblAppImg d-flex">
                  <div className="appleImg">
                    <a className="pointer" onClick={() => window.open('https://apps.apple.com/us/app/ms-logger/id1484770342', '_blank')}>
                      <img style={{ width: '100%' }} src={appleStore} alt=""></img>
                    </a>
                  </div>
                  <div className="playStoreImg">
                    <a className="pointer" onClick={() => window.open('https://play.google.com/store/apps/details?id=com.medsolace.caselog', '_blank')}>
                      <img style={{ width: '100%' }} src={playStore} alt=""></img>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default HomePage;
